// extracted by css-extract-rspack-plugin
export default {"link":"KKzUO","disabled":"zOOAB","brand":"h9uWO","brandBold":"ebPUo"};